import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { AuthService } from './core/services/auth.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  template: '<router-outlet />',
})
export class App implements OnInit {
  private auth = inject(AuthService);

  ngOnInit() {
    // Beim App-Start aktuelle Rechte vom Server holen, damit Admin-Änderungen
    // sofort greifen. Bei abgelaufenem Token ausloggen.
    if (this.auth.isLoggedIn()) {
      this.auth.refreshMe().subscribe({
        error: (err: HttpErrorResponse) => {
          if (err.status === 401 || err.status === 403) {
            this.auth.logout();
          }
        },
      });
    }
  }
}
